//============================
//# hmmetreport
//============================

import { ValidationRules } from "@/models/Validation";

export default interface MetRiportHead {
    id: number;
    name: string;
    foreign: string;
    english: string;
    beginDate: Date | null;
    endDate: Date | null;
    previewBeginDate: Date | null;
    previewEndDate: Date | null;
    status: number;
}

export const MetRiportHeadDefaultProps: MetRiportHead = {
    id: 0,
    name: "",
    foreign: "",
    english: "",
    beginDate: new Date(),
    endDate: null,
    previewBeginDate: new Date(),
    previewEndDate: null,
    status: 2,
}

export const MetRiportHeadValidationRules: ValidationRules = {
    name: [
        (v: string) => !!v || "Kötelező",
        (v: string) => v.replace(/\s+/g, "").length >= 1 || "Nem lehet rövidebb, mint egy karakter"
    ],
    //Kezdő és végdátum validáció csak backenden
}